import Logo from 'ui/src/components/logo'
import { cn } from '@/util/cn'
import { AnchorHTMLAttributes, SyntheticEvent } from 'react'
import Typography from '@/app/components/typography'

type Link = AnchorHTMLAttributes<HTMLAnchorElement> & {
    label: string
}

const LINKS: Link[] = [
    {
        href: '#about-giphy',
        label: 'About GIPHY',
    },
    {
        href: '#recent-news',
        label: 'Recent News',
    },
    {
        href: '#philosophies-and-values',
        label: 'Philosophies and Values',
    },
    {
        href: '#contact',
        label: 'Contact',
    },
    {
        href: '#our-team',
        label: 'Our Team',
    }
]

type Props = {
    className?: string
}

const Navigation = ({ className }: Props) => {
    const onLinkClick = (e: SyntheticEvent<HTMLAnchorElement>) => {
        const bits: string[] = e.currentTarget.href.split('#')
        const selector: string = bits[bits.length - 1] || ''
        const el: HTMLElement | null = document.getElementById(selector)
        e.preventDefault()
        el && el.scrollIntoView({ behavior: 'smooth' })
    }

    return (
        <div className={cn('flex items-center h-[3.75rem] justify-between mx-auto max-w-desktopWidth relative w-full', className)}>
            <div className="flex h-[1.4rem] text-2xl justify-center">
                <Logo className="max-h-full" />
            </div>
            
            <div className="mx-auto hidden flex-wrap gap-6 lg:flex">
                {LINKS.map(({ label, ...rest }) => (
                    <a 
                        key={rest.href}
                        onClick={onLinkClick}
                        {...rest}
                    >
                        <Typography className="text-giphyLightestGrey" fontWeight="bold">
                            {label}
                        </Typography>
                    </a>    
                ))}
            </div>

            <a href="https://giphy.com" className="h-[0.875rem]">
                <svg width="118" height="14" xmlns="http://www.w3.org/2000/svg">
                    <g fill="#FFF" fillRule="evenodd">
                        <path
                            d="M7.615 13L12.223.994H9.829L6.841 9.238 3.403.994H.811L6.121 13h1.494zm6.948-9.666c.468 0 .819-.132 1.053-.396.234-.264.351-.558.351-.882 0-.312-.117-.6-.351-.864-.234-.264-.585-.396-1.053-.396-.468 0-.819.132-1.053.396-.234.264-.351.552-.351.864 0 .324.117.618.351.882.234.264.585.396 1.053.396zM15.733 13V4.324h-2.34V13h2.34zm5.67.198c.516 0 1.002-.054 1.458-.162a3.67 3.67 0 001.188-.495c.336-.222.6-.504.792-.846.192-.342.288-.747.288-1.215 0-.42-.075-.786-.225-1.098a2.215 2.215 0 00-.657-.801 3.705 3.705 0 00-1.053-.549c-.414-.144-.885-.27-1.413-.378-.648-.132-1.092-.258-1.332-.378a.616.616 0 01-.36-.594c0-.24.096-.435.288-.585.192-.15.54-.225 1.044-.225.456 0 .852.096 1.188.288.336.192.612.432.828.72l1.656-1.134c-.312-.456-.756-.843-1.332-1.161-.576-.318-1.356-.477-2.34-.477-1.092 0-1.959.24-2.601.72-.642.48-.963 1.104-.963 1.872 0 .42.072.78.216 1.08.144.3.348.558.612.774.264.216.585.393.963.531s.795.249 1.251.333c.78.144 1.314.312 1.602.504.288.192.432.414.432.666 0 .264-.135.471-.405.621-.27.15-.645.225-1.125.225-.552 0-1.011-.129-1.377-.387a2.737 2.737 0 01-.855-.963l-1.746 1.062c.336.588.825 1.077 1.467 1.467.642.39 1.479.585 2.511.585zm6.57-9.864c.468 0 .819-.132 1.053-.396.234-.264.351-.558.351-.882 0-.312-.117-.6-.351-.864-.234-.264-.585-.396-1.053-.396-.468 0-.819.132-1.053.396-.234.264-.351.552-.351.864 0 .324.117.618.351.882.234.264.585.396 1.053.396zM29.143 13V4.324h-2.34V13h2.34zm5.112.198c.492 0 .957-.081 1.395-.243a6.003 6.003 0 001.251-.639l-.846-1.602a3.902 3.902 0 01-.594.378 1.49 1.49 0 01-.702.18.592.592 0 01-.369-.153c-.126-.102-.189-.291-.189-.567V6.124h2.106v-1.8h-2.106v-2.25h-2.34v2.25h-1.278v1.8h1.278v4.77c0 .42.069.777.207 1.071.138.294.318.531.54.711.222.18.477.312.765.396.288.084.582.126.882.126zm13.734.144c2.43 0 4.626-.864 5.418-2.466V5.278h-6.156v2.79h3.186v1.62c-.72.522-1.764.648-2.43.648-2.538 0-3.384-1.998-3.384-3.618 0-2.466 1.332-3.69 3.384-3.69.846 0 1.962.234 2.88 1.098l2.07-2.052C51.301.4 49.753.04 48.007.04c-4.734 0-6.894 3.384-6.894 6.678s1.89 6.624 6.876 6.624zM58.969 13V.4h-3.546V13h3.546zm6.12 0V9.598h2.556c3.366-.036 5.058-2.034 5.058-4.608 0-2.466-1.674-4.59-5.058-4.59h-6.12V13h3.564zm2.556-6.408h-2.556V3.46h2.556c.972 0 1.494.756 1.494 1.584 0 .828-.504 1.548-1.494 1.548zm10.206 6.426v-4.77h4.536v4.77h3.528V.418h-3.528v4.788h-4.536V.418h-3.564v12.6h3.564zM95.437 13V7.978l5.004-7.416V.4h-4.014l-2.718 4.32L91.099.4h-4.014v.144l4.788 7.434V13h3.564z"
                            fillRule="nonzero"
                        />
                        <path d="M112.003.926c.058 0 .117.024.176.07l5.75 5.746c.048.05.071.111.071.182 0 .07-.023.13-.07.181l-5.751 5.745a.232.232 0 01-.179.076.232.232 0 01-.179-.076l-1.75-1.75a.242.242 0 01-.071-.18c0-.072.023-.131.07-.178l3.819-3.818-3.819-3.819a.242.242 0 01-.07-.179c0-.072.023-.131.07-.178l1.751-1.751a.288.288 0 01.182-.07z" />
                    </g>
                </svg>
            </a>
        </div>
    )
}

export default Navigation
